;(function () {
  'use strict';

  /**
   * jquery.matchHeight
   */
  var matchHeight = {
    init: function (options) {
      var config = $.extend({
        class: '.js-mh'
      }, options);

      if (!$(config.class).length) {
        return false;
      }

      $(config.class).matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false
      });
    }
  };

  /**
   * DOM content loaded
   */
  $(function () {
    matchHeight.init();
  });
}.call(this));
